export * from './new-project.class';
export * from './new-project.model';